module.exports = __webpack_public_path__ + "static/media/ziggo_logo.51012116.svg";